// extracted by mini-css-extract-plugin
module.exports = {"checkbox_wrapper":"loadingTipsModal_checkbox_wrapper__6XFfh","checkbox_label":"loadingTipsModal_checkbox_label__3pKws","checkbox_input":"loadingTipsModal_checkbox_input__aERBA"};